import { FieldDefinition } from './field-definition';

export interface FormGroupDefinition {
  controls: FieldDefinition[];
  title?: string;
  stackedTitle?: boolean;
  hideTitle?: boolean;
  hide?: boolean;
}
